import businessBoxAmenity from 'assets/images/psp/amenities/box.svg';
import twentyFourHourIcon from 'assets/images/psp/amenities/24-hour.svg';
import shopIcon from 'assets/images/icons/psp/shop.svg';
import businessCCAmenity from 'assets/images/icons/psp/CC.svg';
import businessGarageAmenity from 'assets/images/psp/amenities/garage.svg';
import SaveMoney from 'assets/images/psp/save-money.svg';
import { pageTypes } from 'config/pageTypes';
import Locker2 from 'assets/images/psp/FeaturedImages/climate2.webp';
import Locker1 from 'assets/images/sgp/10x30/storageunits.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/truckFeatured3.webp';
import LockerAltImage from 'assets/images/sgp/10x30/largest-unit-size.webp';
import AltContentImage from 'assets/images/sgp/alt-content-images/alt-content-image-optimized.webp';
import HeroImage from 'assets/images/sgp/hero/sgp-general-hero-optimized.webp';
import fourColumnTableImage from 'assets/images/sgp/fourColumnTable.svg';
import twoColumnTableImage from 'assets/images/sgp/twoColumnTable.svg';

const reviews = [
	{
		reviewTitle: 'GREAT, FAST SERVICE!',
		reviewRating: 5,
		reviewText:
			'Great, EASY same day booking of a climate control unit! Just moved two days ago from Yorktown, VA to Watertown, NY into a home that is smaller than the one I left behind. I needed a climate control unit IMMEDIATELY. SpareFoot got me taken of right away. Within an hour, I was unloading my items into my new unit.',
		reviewerInitials: 'M',
		reviewerName: 'Marie',
		link: 'https://www.trustpilot.com/reviews/687bebb48f0f02f6ad8fc25f',
	},
	{
		reviewTitle: 'Saved me so much time by looking…',
		reviewRating: 5,
		reviewText:
			'The SpareFoot rep saved me so much time by looking for units in my area that could hold all my household items. I can’t tell you how grateful I am to be able to find such a wonderful service.',
		reviewerInitials: 'JW',
		reviewerName: 'Jodie Wilson',
		link: 'https://www.trustpilot.com/reviews/681f7244c686ea854a9d70d2',
	},
	{
		reviewTitle: 'Customer service',
		reviewRating: 5,
		reviewText:
			'The SpareFoot customer service representative listened to my needs and found me the absolute perfect place within 5 minutes!',
		reviewerInitials: 'L',
		reviewerName: 'Lee',
		link: 'https://www.trustpilot.com/reviews/681ccbe02c79ce86945f187e',
	},
	{
		reviewTitle: 'Very, very simple to book online',
		reviewRating: 5,
		reviewText:
			'Very, very simple to book online. I called the company right after, and they had my reservation. Will definitely use them again.',
		reviewerInitials: 'D',
		reviewerName: 'Dara Matthews',
		link: 'https://www.trustpilot.com/reviews/68111eca0f2e258317455576',
	},
];

const faqs = [
	{
		question:
			'Can you fit a car in a 10x30 storage unit, and how many vehicles can you store?',
		answer: 'A 10x30 unit works great as a car storage unit. You can fit more than one standard vehicle in a 10x30 unit with room to spare. The 300 square feet and 30-foot length accommodate vehicles up to 25+ feet long, including large trucks, RVs, boats with trailers, and classic car collections. The generous width allows you to park vehicles side by side with walking space between them.',
	},
	{
		question:
			'How much stuff can I fit in a 10x30 storage unit compared to smaller options?',
		answer: "A 10x30 storage unit can accommodate significantly more than smaller alternatives - typically the complete contents of a 4-5+ bedroom home with room for organization. With 2,400-3,000 cubic feet of space, you can fit multiple complete room sets, a full kitchen and laundry appliances, several bedroom suites, and 80-120+ boxes. That's 50% more capacity than a 10x20 unit and double a 10x15 unit.",
	},
	{
		question: 'How do I organize my 10x30 storage unit?',
		answer:
			'Effective arrangement in a 10x30 storage unit starts with zoning your unit strategically.\n' +
			'1. Create three main zones: frequently accessed items near the front, seasonal or rarely used items in the back, and a central aisle for navigation.\n' +
			'2. Use the 30-foot length to your advantage by placing tall items like wardrobes and refrigerators along the back wall, medium furniture along the sides, and boxes stacked in designated corners.\n' +
			'3. Label everything clearly and maintain an inventory list with zone locations. Stack boxes pyramid-style with heavier items on the bottom, and use furniture drawers and appliances for small item storage.\n' +
			'4. Create vertical storage with shelving units along walls. For vehicle storage, position cars first, then fill the remaining space with household items.\n' +
			'5. Leave at least 3 feet of aisle space for safe navigation.\n' +
			'6. Consider using the high ceiling for overhead storage of lightweight, rarely accessed items.\n\n' +
			'This systematic approach maximizes your 2,400-3,000 cubic feet while maintaining easy access to everything stored.',
	},
	{
		question: 'Is a 10x30 climate-controlled storage unit worth it?',
		answer: "A 10x30 climate-controlled unit maintains consistent temperature (55-85°F) and humidity (30-50%) across the entire 300 square feet, while standard units experience outdoor weather fluctuations.\n\n For extensive household storage, the controlled environment prevents warping, mold, rust, and deterioration across your large collection of items. However, for vehicle storage, basic household items, or construction equipment that handles weather exposure, a standard unit saves money while still providing secure storage. The key is matching the protection level to your stored items' value and sensitivity.",
	},
	{
		question: 'Can I live in a 10x30 storage unit?',
		answer:
			'No, you cannot legally live in a storage unit of any size, including a 10x30. While these units offer an impressive 300 square feet of space, storage facilities are zoned for storage purposes only, not as residential dwellings.\n\n' +
			'Living in a storage unit violates:\n\n' +
			'- Local zoning laws and building codes\n' +
			'- Your rental agreement terms\n' +
			'- Health and safety regulations\n\n' +
			'Storage units lack essential living amenities like proper ventilation, plumbing, electrical systems designed for habitation, and emergency exits. Most facilities also have security measures and access restrictions that make residential use impractical.',
	},
];

const alternateContentData = {
	props: {
		type: 'alternatingContent',
		title: 'Looking for a Large Storage Unit?',
		description:
			'If you’re here, chances are that you’re looking for a large storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your large storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space: ',
		additionalProps: {
			paragraph: {
				color: 'black',
			},
		},
		content: [
			{
				image: AltContentImage,
				description:
					'**Medium Units:** 10x10, 10x15, 5x15\n\n' +
					'**Small Units:** 5x5, 5x10, Mini storage, Storage lockers\n\n' +
					'**Large Units:** 10x20, 10x25, 10x30 (*you are here*)',
			},
		],
	},
};

const sgpPageType = 'SGP';

export const TenByThirtyContent = {
	type: '10x30',
	pageType: pageTypes.SGP,
	sections: [
		{
			title: '10x30 Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: '10x30-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							pageType: sgpPageType,
							title: '10x30 Storage Units: When You Need a Large Storage Space',
							inputLabel: 'Find Your Ideal 10x30 Storage Unit',
							description:
								"When you’re in need of extra square footage, the 10x30 storage unit offers 300 square feet of possibilities. Picture this: an entire ranch-style home's worth of belongings, safely housed in one expansive unit. Your car or bike collection is protected from the elements. That growing business inventory that's been taking over [your garage is finally organized](https://www.sparefoot.com/blog/cluttered-garage) in a professional-grade space.",
							image: HeroImage,
							CTAText: 'Find XL Storage Units',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
		{
			title: 'alternate content',
			modules: [
				{
					type: 'alternatingContent',
					id: 'large-storage-unit',
					props: alternateContentData,
				},
			],
		},
		{
			title: 'Why Choose a 10x30 Storage Unit?',
			background: 'gray',
			modules: [
				{
					type: 'cardBlockContent',
					id: '10x30-storage-unit-3-panel-block',
					props: {
						props: {
							title: 'Why Choose a 10x30 Storage Unit?',
							type: 'three-panel',
							pageType: 'SGP',
							description:
								"At 10x30, you're not just renting storage – you're leveling up. These super-sized units transform overwhelming storage challenges into well-managed personal and business inventories.\n\n Whether you're downsizing from a sprawling estate, [safeguarding a fleet of vehicles](https://www.sparefoot.com/car-storage.html), or scaling your enterprise operations, SpareFoot is here to help you grow into the right unit.\n\n When you need serious storage space, a 10x30 storage unit provides unmatched room and flexibility for life's largest storage challenges:",
							additionalProps: {
								paragraph: {
									color: 'black',
								},
							},
							content: [
								{
									image: businessBoxAmenity,
									description:
										'### Warehouse-Level Storage Capacity \n With 300 square feet of floor space, you can store the contents of a 4-5 bedroom home, multiple vehicles, or run a substantial business operation from one convenient location.',
								},
								{
									image: twentyFourHourIcon,
									description:
										'### Ultimate Vehicle Storage Solution \n You can fit multiple cars, [large RVs](https://www.sparefoot.com/rv-storage.html), boats, classic car collections, or combine extensive vehicle storage with household items and equipment.',
								},
								{
									image: shopIcon,
									description:
										'### Business-Grade Storage Power \n Entrepreneurs and growing businesses rely on these units for inventory management, equipment storage, and seasonal merchandise. The generous space handles everything from retail stock to construction equipment and office furniture.',
								},
							],
						},
					},
				},
				{
					type: 'cardBlockContent',
					id: '10x30-storage-unit-3-panel-block-without-header',
					props: {
						props: {
							type: 'three-panel',
							pageType: 'SGP',
							content: [
								{
									image: businessCCAmenity,
									description:
										'### Premium Climate Control Options \n Many facilities offer 10x30 climate-controlled units, providing essential protection for valuable collections, sensitive business inventory, electronics, and irreplaceable family heirlooms.',
								},
								{
									image: businessGarageAmenity,
									description:
										'### Convenient Drive-Up Access \n Most 10x30 drive-up storage units feature extra-wide doors and ground-level access, making it easy to load and unload large items, vehicles, and substantial quantities of belongings.',
								},
								{
									image: SaveMoney,
									description:
										'### Cost-Effective for Large Storage Needs \n When you need this much space, the per-square-foot cost often beats renting multiple smaller units. It’s an economical choice for extensive storage requirements.',
								},
							],
						},
					},
				},
			],
		},
		{
			title: '10x30 Storage Unit Size Guide',
			modules: [
				{
					type: 'sizeChart',
					id: '10x30-small-table-section',
					props: {
						slug: '10x30-small-table-section',
						pageType: sgpPageType,
						title: '10x30 Storage Unit Size Guide',
						tableType: 'specialType',
						image: twoColumnTableImage,
						description:
							'A 10x30 storage unit provides 300 square feet of floor space and typically 2,400-3,000 cubic feet of total storage volume. \n\n Here’s our breakdown on just how big a 10x30 unit is:',
						headers: [
							{
								label: 'Dimension',
								key: 'Dimension',
							},
							{
								label: '10x30 Storage Unit',
								key: '10x30 Storage Unit',
							},
						],
						rows: [
							{
								Dimension: {
									type: 'markdown',
									markdown: '**Floor Space**',
								},
								'10x30 Storage Unit': '300 sq ft',
							},
							{
								Dimension: {
									type: 'markdown',
									markdown: '**Cubic Feet**',
								},
								'10x30 Storage Unit': '2,400-3,000 cu ft',
							},
							{
								Dimension: {
									type: 'markdown',
									markdown: '**Real-World Size**',
								},
								'10x30 Storage Unit':
									'About the size of a large two-car garage',
							},
							{
								Dimension: {
									type: 'markdown',
									markdown: '**Ceiling Height**',
								},
								'10x30 Storage Unit': 'Typically 8-10 feet',
							},
							{
								Dimension: {
									type: 'markdown',
									markdown: '**Door Width**',
								},
								'10x30 Storage Unit': 'Usually 8-12 feet wide',
							},
							{
								Dimension: {
									type: 'markdown',
									markdown: '**Length**',
								},
								'10x30 Storage Unit':
									'30 feet of depth for the organization',
							},
						],
					},
				},
			],
		},
		{
			title: '10x30 Storage Units vs 10x20 Storage Units',
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					id: '10x30-full-tab-section',
					props: {
						pageType: sgpPageType,
						slug: '10x30-full-tab-section',
						title: '10x30 Storage Units vs 10x20 Storage Units',
						isFullWidth: true,
						image: fourColumnTableImage,
						description:
							'What’s the difference between a 10x30 storage unit and a 10x20 storage unit? Let us break down the cost, size, and capacity difference to help you make the right choice.',
						headers: [
							{
								label: 'Feature',
								key: 'Feature',
							},
							{
								label: '10x20 Unit',
								key: '10x20 Unit',
							},
							{
								label: '10x30 Unit',
								key: '10x30 Unit',
							},
							{
								label: 'Advantage',
								key: 'Advantage',
							},
						],
						rows: [
							{
								Feature: {
									type: 'markdown',
									markdown: '**Floor Space**',
								},
								'10x20 Unit': '200 sq ft',
								'10x30 Unit': '300 sq ft',
								Advantage: '+50% more space',
							},
							{
								Feature: {
									type: 'markdown',
									markdown: '**Typical Cost**',
								},
								'10x20 Unit': '$90-300/month',
								'10x30 Unit': '$120-400/month',
								Advantage: 'Better value per sq ft',
							},
							{
								Feature: {
									type: 'markdown',
									markdown: '**Home Contents**',
								},
								'10x20 Unit': '3-4 bedrooms',
								'10x30 Unit': '4-5+ bedrooms',
								Advantage: 'Handles larger homes',
							},
							{
								Feature: {
									type: 'markdown',
									markdown: '**Vehicle Capacity**',
								},
								'10x20 Unit': '1-2 cars',
								'10x30 Unit': '2-3+ cars',
								Advantage: 'Multiple vehicle storage',
							},
						],
					},
				},
			],
		},
		{
			title: 'How Much Furniture Can Fit in a 10x30 Storage Unit?',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					id: '10x30-video-section',
					props: {
						src: 'https://www.youtube.com/embed/gDM6wZDpieE',
						content: {
							title: 'How Much Furniture Can Fit in a 10x30 Storage Unit?',
							description:
								"A 10x30 storage unit provides enough space for an entire 4-5 bedroom estate, including multiple living room sets, full appliance suites, and several bedroom sets with king-size beds. It's also ideal for commercial use, offering sufficient room for medium-sized retail inventory, complete office buildouts, construction equipment, event planning supplies, or restaurant equipment.",
						},
					},
				},
			],
		},
		{
			title: '10x30 Storage Unit Cost Breakdown',
			modules: [
				{
					type: 'sizeChart',
					id: '10x30-cost-breakdown-table-section',
					props: {
						pageType: sgpPageType,
						slug: '10x30-cost-breakdown-table-section',
						title: '10x30 Storage Unit Cost Breakdown',
						description:
							'Location and amenities like climate control and drive-up access can impact the price of your 10x30 storage unit. Here’s how the pricing variations shake out for the average storage user:',
						headers: [
							{ label: 'Location Type', key: 'LocationType' },
							{ label: 'Standard Unit', key: 'StandardUnit' },
							{
								label: 'Climate Controlled',
								key: 'ClimateControlled',
							},
							{
								label: 'Drive-Up Premium',
								key: 'DriveUpPremium',
							},
						],
						rows: [
							{
								LocationType: {
									type: 'markdown',
									markdown: '**Cities**',
								},
								StandardUnit: '$150 - $400',
								ClimateControlled: '$200 - $500',
								DriveUpPremium: '$170 - $450',
							},
							{
								LocationType: {
									type: 'markdown',
									markdown: '**Suburban Areas**',
								},
								StandardUnit: '$120 - $320',
								ClimateControlled: '$160 - $400',
								DriveUpPremium: '$140 - $360',
							},
							{
								LocationType: {
									type: 'markdown',
									markdown: '**Rural Areas**',
								},
								StandardUnit: '$90 - $250',
								ClimateControlled: '$130 - $320',
								DriveUpPremium: '$110 - $280',
							},
						],
					},
				},
			],
		},
		{
			title: 'Review Section',
			background: 'dark',
			modules: [
				{
					id: '10x30-review-section',
					type: 'reviews',
					props: {
						reviews: reviews,
						title: 'Join Thousands of Other Happy SpareFoot 10x30 Storage Users',
						pageType: 'SGP',
					},
				},
			],
		},
		{
			title: 'FAQs Section',
			background: 'gray',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '10x30 Storage Unit Size FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: '10x30-featured-content',
						pageType: 'SGP',
						title: 'Learn More About Storage Unit Size Options',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: Locker1,
								link: 'https://www.sparefoot.com/blog/10x30-storage-unit-size-guide',
								content:
									'What Fits in a 10x30 Storage Unit?',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Locker2,
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
								content: 'How Are Storage Units Measured?',
							},
							{
								title: 'Self Storage',
								date: 'October 17, 2025',
								image: LockerAltImage,
								link: 'https://www.sparefoot.com/blog/5x5-storage-unit-size-guide',
								content:
									'5 Ways to Use the Largest Storage Unit Size',
							},
							{
								title: 'How to Store It',
								date: 'October 29, 2025',
								image: Featured3,
								link: 'https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit',
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'gray',
			modules: [
				{
					type: 'links',
					props: {
						pageType: 'SGP',
						title: 'More Ways to Store',
						cards: ['DriveUp', 'Truck', '10x20', '10x25'],
					},
				},
			],
		},
		{
			title: 'nearby cities',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
